import { Pipe, PipeTransform } from '@angular/core';
import { Values } from '../../common/util/values';

@Pipe({ name: 'enumLabel' })
export class EnumLabelPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    return Values.getLabel(obj, args);
  }
}
